<template>
  <div v-if="!compact">{{ value }}</div>
  <div v-else class="og-status-label" :title="value">
    <div class="og-status-label__text">{{ parts.label }}</div>
    <div v-if="parts.detail" class="og-status-label__detail">{{ parts.detail }}</div>
  </div>
</template>

<script>
/**
 * Estado abreviado para las celdas de las rejillas de control (p. ej. Control contable), donde
 * hay muchas columnas de estado y se busca verlas de un vistazo. El color de la celda sigue
 * dando el significado y el texto completo queda en el `title`.
 *
 * "CONTABILIZADO - 01-04-2025" se muestra como "CONTAB." y, debajo y en pequeño, "01/04/25".
 * "NO TIENE (manual)" se muestra como "NO TIENE" y, debajo, "manual".
 * Con `compact` a false (vista extensa) se muestra el valor tal cual.
 */
const SHORT_LABELS = {
  CONTABILIZADO: 'CONTAB.',
  'NO CONTABILIZADO': 'NO CONTAB.',
  'EN PROCESO': 'EN PROC.',
  'NO NECESARIO': 'NO NEC.',
  'TRIMESTRAL/INACTIVA': 'TRIM./INACT.',
  'FUERA DE PLAZO': 'FUERA PLAZO',
  'PRIMER AVISO': '1er AVISO',
  'SEGUNDO AVISO': '2º AVISO',
  'COMUNICADO NO APLICADO': 'COMUN. NO APLIC.',
};

const WITH_DATE = /^(.*\S)\s+-\s+(\d{2})-(\d{2})-\d{2}(\d{2})$/;
const WITH_NOTE = /^(.*\S)\s+\(([^)]+)\)$/;

export default {
  name: 'OgStatusLabel',
  props: {
    value: { type: String, default: '' },
    compact: { type: Boolean, default: true },
  },
  computed: {
    parts() {
      const value = (this.value || '').trim();
      let label = value;
      let detail = '';
      const withDate = value.match(WITH_DATE);
      const withNote = value.match(WITH_NOTE);
      if (withDate) {
        label = withDate[1];
        detail = `${withDate[2]}/${withDate[3]}/${withDate[4]}`;
      } else if (withNote) {
        label = withNote[1];
        detail = withNote[2];
      }
      return { label: SHORT_LABELS[label] || label, detail };
    },
  },
};
</script>

<style scoped>
.og-status-label {
  line-height: 1.15;
  white-space: nowrap;
}
.og-status-label__detail {
  font-size: 9px;
  opacity: 0.85;
}
</style>
